import { FC } from 'react';
import { SFiltersRow } from '../styles';
import TemplateSearchInput from '../components/TemplateSearchInput';

interface Props {
    onSearch: (query: string) => void;
}

const ItemFieldTemplatesFilters: FC<Props> = ({ onSearch }) => (
    <SFiltersRow>
        <TemplateSearchInput onSearch={onSearch} />
    </SFiltersRow>
);

export default ItemFieldTemplatesFilters;
